export class UpdateRetentionSchedule {
    constructor(retentionScheduleRepository) {
      this.retentionScheduleRepository = retentionScheduleRepository;
    }  
    async execute(UpdateRetentionScheduleRequest) {
      return await this.retentionScheduleRepository.updateRetentionSchedule(UpdateRetentionScheduleRequest);
  }
}